import React from 'react';
import { useSelector } from 'react-redux';
import './style.css';
import EditorTabPanelElements from './editorTabPanelElements/EditorTabPanelElements';
import EditorTabPanelInspector from './editorTabPanelInspector/EditorTabPanelInspector';
import { EDITOR_TAB_PANEL_ELEMENTS, EDITOR_TAB_PANEL_INSPECTOR } from '../../../../utilities/constants/editorConstants';

export const TabPanels = React.memo(() => {
  const tabPanel = useSelector((state) => state.editor.tabPanel);
  const isInspectorActive = tabPanel === EDITOR_TAB_PANEL_INSPECTOR;
  const isElementsActive = !isInspectorActive;

  return (
    <>
      <div
        className={`tab-panel-wrapper${isElementsActive ? ' tab-panel-wrapper--active' : ' tab-panel-wrapper--hidden'}`}
        data-tab-panel="elements"
      >
        <EditorTabPanelElements />
      </div>
      <div
        className={`tab-panel-wrapper${isInspectorActive ? ' tab-panel-wrapper--active' : ' tab-panel-wrapper--hidden'}`}
        data-tab-panel="inspector"
      >
        <EditorTabPanelInspector />
      </div>
    </>
  );
});

export default TabPanels;
